import React from "react";
import { assets } from "../../styles/css-variables";

const Loader = ({ isLoaderVisible }) => {
  return (
    <div id="loadingIndicator">
      <div className={`loading-overlay${isLoaderVisible ? " visible" : ""}`}>
        <div className="loading-indicator">
          {isLoaderVisible && <img src={assets.searchLoader} alt="Loading..." />}
        </div>
      </div>
    </div>
  );
};

export default Loader;
